import * as ngCore from '@angular/core'
import * as ngrxEffects from '@ngrx/effects'
import * as ngrxStore from '@ngrx/store'

/**
 * TODO:
 */
@ngCore.Injectable({ providedIn: 'root' })
export class InjectableDependencies {
  /** @see {@link ngrxStore.Store} */
  public readonly store = ngCore.inject(ngrxStore.Store<any>)
  /** @see {@link ngrxEffects.Actions} */
  public readonly actions = ngCore.inject(ngrxEffects.Actions<any>)
}
